import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from "moment";
import { MyUtils } from 'src/app/services/my-utils.service';
import { RecoveryPlanService } from 'src/app/services/recovery-plan.service';

@Component({
  selector: 'app-recovery-plan-info',
  templateUrl: './recovery-plan-info.component.html',
  styleUrls: ['./recovery-plan-info.component.css']
})
export class RecoveryPlanInfoComponent implements OnInit {
  openInfo = false;
  info: any = []
  constructor(
    public utils: MyUtils,
    private recoveryPlanService: RecoveryPlanService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.info = []
    this.info.push({title:"title",value: this.data.title})
    this.info.push({title:"description",value: this.data.description})
    this.info.push({title:"surveyId",value: this.data.surveyRequestId})
    this.info.push({title:"surveyDate",value: moment(this.data.dateStart).format("DD-MM-YYYY"), })
    this.info.push({title:"outletId",value: this.data.outletId})
    this.info.push({title:"dateStart",value: moment(this.data.dateStart).format("DD-MM-YYYY") })
    this.info.push({title:"dateEnd",value: moment(this.data.dateStart).format("DD-MM-YYYY")})
  }
  parseDate(timestamp: number | string) {
    if (timestamp && timestamp !== "not valid" && timestamp !== "valid") {
      let date = new Date(timestamp);
      return moment(date).format('DD/MM/YYYY, hh:mm');
    } else {
      return "";
    }
  }
  downloadFile() {
    this.recoveryPlanService.getRecoveryPlanAttach(this.data.brand!, this.data.region!, this.data.recoveryPlanId!).subscribe(data => {

  })
}
}
